/// <amd-module name="typeahead/core/plugins/ExecutionHelper" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/typeahead/browser.d.ts" />
/// <reference path="../../../typings/typeahead/modulizr.d.ts" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />

import {ABTest} from "typeahead/core/ABTest";
import {Experiment} from "typeahead/core/Experiment";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

// prop mapping between StripingConfigration's properties and Context's properties

const supportedProperties = {
    clients : "clientId",
    deviceTypes : "deviceType",
    lobs : "lob",
    locales: "locale",
    siteids : "siteid",
    tabs : "tab",
};

export const abTest = new ABTest();

export function evaluateExperiment(experiment: Experiment, deferred: JQueryDeferred<boolean>) {
    if (experiment.name) {
        abTest.getAndLog(experiment.name)
            .done((exp: Experiment) => {
                deferred.resolve(typeof experiment.value !== "undefined" ?
                    experiment.value === exp.value : exp.value > 0);
            })
            .fail(() => {
                deferred.resolve(false);
            });
    } else {
        deferred.resolve(false);
    }
}

function getContextProp(configProp: string): string {
    return supportedProperties.hasOwnProperty(configProp) ? supportedProperties[configProp] : null;
}

function getApplicableConfiguration(
                    context: IContext, stripingConfigurations: IStripingConfiguration[]): IStripingConfiguration {

    let stripingConfiguration: IStripingConfiguration;
    for (let i: number = 0; i < stripingConfigurations.length; i++) {
        stripingConfiguration = stripingConfigurations[i];
        let isConfigApplicable: boolean = true;

        for (let configProp in stripingConfiguration) {
            if (configProp !== "experiment" && stripingConfiguration.hasOwnProperty(configProp) &&
                                                                            stripingConfiguration[configProp]) {
                let contextProp: string = getContextProp(configProp);
                if (contextProp && stripingConfiguration[configProp].indexOf(context[contextProp]) < 0) {
                    isConfigApplicable = false;
                    break;
                }
            }
        }
        if (isConfigApplicable) {
            return stripingConfiguration;
        }
    }
    return undefined;
}

// the abTestInstance optional argument is for unit testing
export function shouldExecute(context: IContext, stripingConfigurations: IStripingConfiguration[],
                              abTestInstance = abTest):
        JQueryPromise<boolean> {

    let deferred: JQueryDeferred<boolean> = $.Deferred();
    if (!stripingConfigurations || !stripingConfigurations.length ||  !context) {
        return deferred.resolve(true).promise();
    }

    let stripingConfig: IStripingConfiguration = getApplicableConfiguration(context, stripingConfigurations);

    if (stripingConfig) {
        let experiment = stripingConfig.experiment;
        if (experiment) {
            if (abTestInstance.hasAbovExp(experiment.id)) {
                deferred.resolve(abTestInstance.getAbovValue(experiment.id) > 0);
            } else if (abTestInstance.hasEvaluatedExp(experiment.name)
                && !abTestInstance.hasControlLockedExp(experiment.name)) {
                TypeaheadErrorLogger.log(new Error("Evaluated exp: " + experiment.id + " " + experiment.value),
                    Severity.Negligible, ProblemOrigin.UniversalTypeahead);
                abTestInstance.logExperimentAsynchronously(experiment.name);

                let bucket = abTestInstance.getABTestMap()[experiment.name].value;
                deferred.resolve(bucket > 0);
            } else {
                abTestInstance.lockExperimentToControl(experiment);
                deferred.resolve(false);
            }
        } else {
            deferred.resolve(true);
        }
    } else {
        deferred.resolve(false);
    }
    return deferred.promise();

}
